import { useCallback, useContext } from 'react';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import useWizardJump from '@swf/core/hooks/useWizardJump';

import useRmfFirstScreen from '../components/RMF/hooks/useRmfFirstScreen';
import { CashierFlowType } from '../types/Cashier';

const isStartOfCashierFlow = (cashierFlow: CashierFlowType, rmfTargetToJump?: string) => {
  const isCashierFlow = [
    CashierFlowType.FirstDeposit,
    CashierFlowType.FirstP2pTransfer,
    CashierFlowType.FirstWithdraw
  ].includes(cashierFlow);

  if (
    isCashierFlow &&
    rmfTargetToJump !== '#deposit.deposit-process' &&
    rmfTargetToJump !== '#withdraw.get-cashout-options'
  ) {
    return true;
  }
  return false;
};

const useRmfFirstScreenBackButton = () => {
  const { goPrevious } = useContext(NavigationContext);
  const { jumpBack } = useWizardJump();
  const isFirstScreen = useRmfFirstScreen();
  const exitWizard = useWizardExit();

  const {
    data: { cashierFlow, rmfTargetToJump, depositRmfRequiredPageVisited }
  } = useWizardContext();

  const inStartOfCashierFlow = isStartOfCashierFlow(cashierFlow, rmfTargetToJump);
  const showBackButton = !isFirstScreen || inStartOfCashierFlow;

  const inBeginningOfDeposit =
    cashierFlow === CashierFlowType.FirstDeposit && isFirstScreen && depositRmfRequiredPageVisited;
  const inBeginningOfCashierFlow = isFirstScreen && inStartOfCashierFlow;

  const handleClick = useCallback(() => {
    if (inBeginningOfDeposit) return jumpBack('#deposit.deposit-suspended');
    if (inBeginningOfCashierFlow) return exitWizard();
    return goPrevious();
  }, [exitWizard, goPrevious, inBeginningOfDeposit, inBeginningOfCashierFlow, jumpBack]);

  return { showBackButton, handleClick };
};

export default useRmfFirstScreenBackButton;
